<template>
  <svg
    v-if="symbol"
    class="mtx-svg"
    :class="{ [`mtx-icon ${symbol}`]: icon }"
    :viewBox="fill ? '0 0 1 1' : false"
  >
    <use v-bind:xlink:href="`#${symbol}`"></use>
  </svg>
</template>

<script>
export default {
  props: {
    src: String,
    icon: [Boolean, String],
    fill: Boolean
  },

  computed: {
    symbol() {
      return this.src || this.icon
    }
  }
}
</script>

<style lang="scss">
.mtx-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
}
</style>
